<template>
	<div class="shadow-md outline-2 outline-grey-700 rounded px-2 py-2">
		<div
			v-if="typeof value === 'string'"
			class="my-3"
			v-for="(value, propertyName, index) in values"
			:key="index">
			<label
				:for="'service_' + propertyName"
				class="block font-bold mb-2 text-lg"
				>{{
					propertyName.charAt(0).toUpperCase() + propertyName.slice(1)
				}}
				du service</label
			>
			<input
				class="w-50 shadow rounded leading-relaxed border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-900 focus:border-b-2"
				type="text"
				:id="'service_' + propertyName"
				v-model="values[propertyName]" />
		</div>

		<hr />

		<div class="block font-bold mb-2 text-lg">
			Clés d'authentification
			<span
				v-b-tooltip.hover="{
					variant: 'info',
					title: 'Cliquez ici pour entrer vos clés sur la page Clés de sécurité puis entrez leurs noms ici',
				}"
				class="inline ml-2">
				<a
					target="_blank"
					href="/credentials"
					class="fa fa-info-circle"></a>
			</span>
		</div>
		<div
			v-for="(keyName, index) in values.keyNames"
			:key="'keys_' + index"
			class="my-3">
			<div class="flex">
				<input
					class="w-50 shadow rounded leading-relaxed border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-900 focus:border-b-2"
					type="text"
					:id="'service_' + keyName + '_' + index"
					v-model="keyName.keyName" />
				<span
					class="ml-2 cursor-pointer"
					@click="() => values.keyNames.splice(index, 1)">
					<i class="fa fa-times" aria-hidden="true"></i>
				</span>
			</div>
		</div>

		<div>
			<b-button
				class="m-md-2"
				variant="outline-primary"
				@click="
					() =>
						values.keyNames.push({
							keyName: '',
						})
				">
				Ajouter une clé
			</b-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "service_type",
		components: {},
		data() {
			return {
				values: {
					description: "",
					url: "",
					// * syntaxe comme ça pour pouvoir v-model dans le v-for
					keyNames: [
						{
							keyName: "",
						},
					],
				},
			};
		},
		methods: {
			async save() {
				let data = {
					parameters: this.values,
				};

				return data;
			},
			async load(data) {
				this.values = data.parameters;
			},
		},
	};
</script>
